// The Sero product page: keep the delivery note in step with the selected size.
(() => {
  const toggleDelivery = ({ data }) => {
    if (!data) return;
    document
      .querySelectorAll(`[data-product-delivery][data-section="${data.sectionId}"]`)
      .forEach((note) => note.classList.toggle('hidden', !(data.variant && data.variant.available)));
  };
  const listen = () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, toggleDelivery);
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', listen);
  } else {
    listen();
  }
})();

// Mobile gallery: swipe with dots instead of arrows and "1/8".
(() => {
  const mobile = window.matchMedia('(max-width: 749px)');

  const buildDots = (viewer) => {
    const list = viewer.querySelector('.product__media-list');
    if (!list || viewer.querySelector('.product-gallery-dots')) return;
    const dots = document.createElement('div');
    dots.className = 'product-gallery-dots';
    dots.setAttribute('aria-hidden', 'true');
    viewer.appendChild(dots);

    const slides = () => [...list.children].filter((slide) => slide.offsetParent !== null);
    const render = () => {
      const items = slides();
      dots.innerHTML = items.length > 1 ? items.map(() => '<span></span>').join('') : '';
      update();
    };
    const update = () => {
      const items = slides();
      if (!items.length) return;
      const start = list.getBoundingClientRect().left;
      let active = 0;
      let best = Infinity;
      items.forEach((slide, index) => {
        const distance = Math.abs(slide.getBoundingClientRect().left - start);
        if (distance < best) {
          best = distance;
          active = index;
        }
      });
      [...dots.children].forEach((dot, index) => dot.classList.toggle('is-active', index === active));
    };

    list.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
    // Variant changes show or hide slides; rebuild the dots when that happens.
    new MutationObserver(render).observe(list, { attributes: true, subtree: true, attributeFilter: ['class'] });
    render();
  };

  const init = () => {
    if (!mobile.matches) return;
    document.querySelectorAll('media-gallery slider-component[id^="GalleryViewer-"]').forEach(buildDots);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  mobile.addEventListener('change', init);
})();

// Size guide link: open the Tailor app's guide when the app shows one for this product.
(() => {
  const connect = () => {
    document.querySelectorAll('[data-size-guide]').forEach((link) => {
      link.closest('.product-size-guide-wrapper')?.classList.add('product-size-guide-wrapper--inline');
      const info = link.closest('.product__info-container');
      const appWrapper = info && info.querySelector('.find-my-size-button-wrapper');
      const appButton = appWrapper && appWrapper.querySelector('.find-my-size-button');
      const appReady = () => appWrapper && getComputedStyle(appWrapper).display !== 'none';
      const sync = () => {
        if (link.dataset.finderTarget) return;
        if (appReady()) link.hidden = false;
        else if (link.dataset.hasPage !== 'true') link.hidden = true;
      };
      if (appWrapper) new MutationObserver(sync).observe(appWrapper, { attributes: true });
      sync();
      setTimeout(sync, 1500);
      link.addEventListener('click', (event) => {
        if (link.dataset.finderTarget) return;
        if (appReady() && appButton) {
          event.preventDefault();
          event.stopPropagation();
          appButton.click();
        }
      }, true);
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', connect);
  } else {
    connect();
  }
})();
